import { connect, ConnectedProps } from 'react-redux';
import { StoreState } from '@root/types';
import { hasAdminUser } from '@store/selectors';
import { ValidIconTypes } from '@components/shared/CustomIcon';
import classNames from 'classnames';
import Drink from './Drink';
import s from './Bartender.module.less';

const mapState = (state: StoreState) => ({
  isAdmin: hasAdminUser(state),
});

const connector = connect(mapState);
type ReduxProps = ConnectedProps<typeof connector>;

type PassedProps = {
  drinks: Array<{ url: string; tooltipText: string; icon: ValidIconTypes }>;
  className?: string;
};

function Bartender({ className, drinks, isAdmin }: PassedProps & ReduxProps) {
  if (!isAdmin) return null;

  return (
    <ul data-testid="bartender" className={classNames(s.bartender, className)}>
      {drinks.map(props => (
        <Drink key={props.url} {...props} />
      ))}
    </ul>
  );
}

export default connector(Bartender);
